module.exports = __webpack_public_path__ + "img/180.16d328b3.jpg";